import React from 'react';
import { CheckCircleIcon, XMarkIcon } from '@heroicons/react/24/solid';

/**
 * SuccessModal - Displays a success message in a modal with an accept button
 * Used for showing important success messages that require user acknowledgment
 */
export default function SuccessModal({ isOpen, title, message, onClose, onCloseClick, onOkClick, buttonText = 'Got it' }) {
  if (!isOpen) return null;

  const handleCloseClick = () => {
    onCloseClick?.();
    onClose();
  };

  const handleOkClick = () => {
    onOkClick?.();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={handleCloseClick}
      />
      
      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md transform overflow-hidden rounded-xl bg-white shadow-2xl transition-all">
          {/* Close button */}
          <button
            type="button"
            className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition-colors"
            onClick={handleCloseClick}
          >
            <XMarkIcon className="h-5 w-5" />
          </button>

          {/* Content */}
          <div className="p-6 text-center">
            {/* Success icon */}
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
              <CheckCircleIcon className="h-10 w-10 text-green-600" />
            </div>

            {/* Title */}
            <h3 className="mb-2 text-xl font-semibold text-gray-900">
              {title}
            </h3>

            {/* Message */}
            <p className="mb-6 text-gray-600 leading-relaxed">
              {message}
            </p>

            {/* Accept button */}
            <button
              type="button"
              onClick={handleOkClick}
              className="w-full rounded-lg bg-green-600 px-5 py-3 text-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-4 focus:ring-green-300 transition-colors"
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
